// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import ConsultationPage from "./pages/ConsultationPage";
import PrescriptionPage from "./pages/PrescriptionPage";
import VaccinationPage from "./pages/VaccinationPage";
import LocationPage from "./pages/LocationPage";
import ContactUsPage from "./pages/ContactUsPage";
import TransferPage from "./pages/TransferPage";
import AboutPage from "./pages/AboutPage";
import Footer from "./components/Footer";
import ScrollToTop from "./hooks/ScrollToTop";

function App() {
  return (
    <Router>
      {/* ScrollToTop will reset the scroll position on every route change */}
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/consultation" element={<ConsultationPage />} />
        <Route path="/prescription" element={<PrescriptionPage />} />
        <Route path="/vaccination" element={<VaccinationPage />} />
        <Route path="/location" element={<LocationPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/transfers" element={<TransferPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
